import * as _ from 'underscore';

import { BrowserTitleService } from '../../commonInfra/services/BrowserTitleService';
import { FeatureFlags } from '../FeatureFlags';
import { IFeatureFlagsDoNotUse } from '../ServerApi/types/IFeatureFlagsDoNotUse';
import { IHost } from '../../serverStatus/types/IHost';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { ServerInfoService } from '../../serverStatus/services/ServerInfoService';
import { ServerService } from '../services/ServerService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { ServerUrls } from '../../app/ServerUrls';
import { WorkerProcessType } from '../ServerApi/types/IWorkerProcess';
import { WorkerStatusType } from '../ServerApi/requests/GetWorkerProcessStatus';

export interface IServerStatusScope extends ng.IScope {
  hosts: IHost[];
  components: string[];
  legendStatuses: string[];
  refreshButtonBusy: boolean;
  showAdminViews: boolean;
  showMultinodePrimaryWorkerLabels: () => boolean;
  isPreferred: (component: string, host: IHost) => boolean;
  refreshStatuses: () => void;
  hideStatsForLoadTimes: () => boolean;
  hidePerformanceofViews: () => boolean;
  hidePerformanceofFlowRuns: () => boolean;
  analysisUrl: (sheetUrlId: string) => string;
}

export class ServerStatusCtrl {
  public static refreshProcessStatusEvent = 'refreshProcessStatus';
  private static legendStatuses = [
    WorkerStatusType.active,
    WorkerStatusType.busy,
    WorkerStatusType.passive,
    WorkerStatusType.unlicensed,
    WorkerStatusType.down,
    WorkerStatusType.external,
    WorkerStatusType.statusNotAvailable,
 ];
  private static WorkerProcessTypes = [
    WorkerProcessType.clusterController, // cluster controller should be first
    WorkerProcessType.gateway,
    WorkerProcessType.vizportal,
    WorkerProcessType.wgServer,
    WorkerProcessType.vizqlServer,
    WorkerProcessType.cacheServer,
    WorkerProcessType.searchServer,
    WorkerProcessType.backgrounder,
    WorkerProcessType.dataServer,
    WorkerProcessType.dataEngine, // TFS 646124 - Remove the feature flag, remove the dataengine.
    WorkerProcessType.hyper,
    WorkerProcessType.fileStore,
    WorkerProcessType.repository,
    WorkerProcessType.flowProcessor,
    WorkerProcessType.metrics
  ];

  private featureFlagsDoNotUse: IFeatureFlagsDoNotUse;
  private wgEnabled: boolean;
  private flowProcessorEnabled: boolean;

  public static $inject = [
    '$scope',
    'ServerService'
  ];

  constructor(
    $scope: IServerStatusScope,
    server: ServerService
  ) {
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverStatus()});

    $scope.showAdminViews = !server.isAdminViewsDisabled();

    // Server Status Grid
    this.featureFlagsDoNotUse = server.featureFlagsDoNotUse(); // move these flags to server settings (TFS: 653138)
    this.wgEnabled = ServerSettingsUnauthenticated.isWgEnabled();
    this.flowProcessorEnabled = server.flowProcessorEnabled();
    $scope.showMultinodePrimaryWorkerLabels = () => {
      return $scope.hosts.length > 1 && !FeatureFlags.tableauServicesManagerEnabled;
    };
    $scope.components = this.getComponents($scope.hosts);
    $scope.legendStatuses = ServerStatusCtrl.legendStatuses;
    $scope.isPreferred = (component: string, host: IHost): boolean => {
      return component === WorkerProcessType.repository
        && this.featureFlagsDoNotUse.ha2Enabled
        && host.processes
        && host.processes[WorkerProcessType.repository]
        && host.processes[WorkerProcessType.repository][0].preferred;
    };
    $scope.refreshStatuses = () => {
      $scope.refreshButtonBusy = true;
      ServerInfoService.fetch()
        .then((hosts: IHost[]) => {
          $scope.hosts = hosts; // Update hosts if server config has changed
          $scope.$broadcast(ServerStatusCtrl.refreshProcessStatusEvent);
        })
        .finally(() => $scope.refreshButtonBusy = false);
    };

    $scope.hideStatsForLoadTimes  = () => {
      return ServerSettingsUnauthenticated.hideAdminVizStatsForLoadTimes();
    };

    $scope.hidePerformanceofViews  = () => {
      return ServerSettingsUnauthenticated.hideAdminVizPerformanceofViews();
    };

    $scope.hidePerformanceofFlowRuns  = () => {
      return server.hideAdminVizPerformanceofFlowRuns();
    };

    $scope.analysisUrl = (sheetUrlId: string) => {
      return ServerUrls.getInstance().serverStatusVizUrl(sheetUrlId);
    };
  }

  private getComponents(hosts: IHost[]): string[] {
    return _.without(ServerStatusCtrl.WorkerProcessTypes,
        ((this.featureFlagsDoNotUse && !this.featureFlagsDoNotUse.ha2Enabled) || (this.featureFlagsDoNotUse && !this.featureFlagsDoNotUse.ha2FilestoreEnabled) ? WorkerProcessType.fileStore : ''),
        ((this.featureFlagsDoNotUse && !this.featureFlagsDoNotUse.ha2Enabled) || hosts.length === 1 ? WorkerProcessType.clusterController : ''),
        (!this.wgEnabled ? WorkerProcessType.wgServer : ''),
        // TFS 646124 - Remove the feature flag, remove this check.
        (FeatureFlags.hyperOnServerEnabled ? WorkerProcessType.dataEngine : WorkerProcessType.hyper),
        // Tableau Prep Server Flow Processor
        (!this.flowProcessorEnabled ? WorkerProcessType.flowProcessor : '')
      );
  }

}

Module.instance().controller('ServerStatusCtrl', ServerStatusCtrl);
